/**
 * 二维码相关服务
 * @author wanghui@gwdang.com
 */

const QrCode = {

    // 获取绑定公众号二维码
    getBindQrCode(userid) {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: "/collect/get_qrcode/?st=change&user_id="+userid,
                dataType:"json",
                success(msg) {
                    if(msg != -1){
                        resolve("https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket="+msg.tk);
                    } else {
                        reject(msg);
                    }
                }
            })
        });
    }
};

export default QrCode;
